<template>
	<tbody class="analytics-step">
		<StepAnalyticsRowV2 :step="step" @click="hidePages=!hidePages" :open="!hidePages"
		                    :start-date="startDate" :end-date="endDate" :old-end-date="oldEndDate" :old-start-date="oldStartDate"
		                    :get-conditions="getConditions" :loading-steps="loadingSteps"/>

		<template v-if="!hidePages">
			<template v-if="visiblePages.length > 0" v-for="(page) in visiblePages">
				<PageAnalyticsRowV2 :page="page" :showProducts="!page.hideProducts"
				                    :start-date="startDate" :end-date="endDate" :old-end-date="oldEndDate" :old-start-date="oldStartDate"
				                    :get-conditions="getConditions" :loading-steps="loadingSteps"
				                    @nameClicked="$set(page,'hideProducts', !page.hideProducts)"  />

				<template v-if="!page.hideProducts">
					<product-analytics-row-v2 v-if="visibleProducts(page).length > 0"
					                          :page="page" :product="p" v-for="p in visibleProducts(page)"  />

					<template v-if="page.showHiddenProducts && hiddenProducts(page).length>0">
						<product-analytics-row-v2 :page="page" :product="p" v-for="p in hiddenProducts(page)"  />
					</template>

					<template v-if="hiddenProducts(page).length>0">
						<product-analytics-row-v2 :page="{page_id:0,name:'hidden'}"
						                          :product="{product_id:0,name:'hidden'}" :showHiddenPages="page.showHiddenProducts"
						                          @showMore="$set(page,'showHiddenProducts',!page.showHiddenProducts)" />
					</template>
				</template>
			</template>

			<template v-if="hideHiddenPages && hiddenPages.length>0">
				<PageAnalyticsRowV2 :page="page" v-for="(page) in hiddenPages" :loading-steps="loadingSteps"
				                    :start-date="startDate" :end-date="endDate" :old-end-date="oldEndDate" :old-start-date="oldStartDate"
				                    :get-conditions="getConditions"/>
			</template>

			<template v-if="hiddenPages.length>0">
				<PageAnalyticsRowV2 :page="{page_id:0,name:'hidden'}"
				                    :start-date="startDate" :end-date="endDate" :old-end-date="oldEndDate" :old-start-date="oldStartDate"
				                    :get-conditions="getConditions" :loading-steps="loadingSteps"
				                    :showHiddenPages="hideHiddenPages"
				                    @showMore="hideHiddenPages=!hideHiddenPages" />
			</template>
		</template>

	</tbody>
</template>

<script>
import VButton from "@/components/base/v-button";
import StepAnalyticsRowV2 from "@/views/funnels/funnel-plus/funnel/analytics/step_analytics_row.v2";
import PageAnalyticsRowV2 from "@/views/funnels/funnel-plus/funnel/analytics/page_analytics_row.v2";
import ProductAnalyticsRowV2 from "@/views/funnels/funnel-plus/funnel/analytics/product_analytics_row.v2";
import API from "@/api";
export default {
	name: "analytics-step-v2",
	components: {
		ProductAnalyticsRowV2,
		PageAnalyticsRowV2,
		StepAnalyticsRowV2,
		VButton},
	props: ["step", "showPages", "loadingSteps",'startDate', 'endDate','oldStartDate', 'oldEndDate', 'getConditions'],
	mixins: [API],
	data(){
		return {
			hidePages: !this.showPages,
			hideHiddenPages: false,
			loading:false,
		}
	},
	computed:{
		hiddenPages() {
			return this.step.pages ? this.step.pages.filter(x => x.is_deleted) : []
		},
		visiblePages() {
			return this.step.pages ? this.step.pages.filter(x => !x.is_deleted) : []
		},
	},
	methods:{
		hiddenProducts(page) {
			return page.products ? page.products.filter(x => x.is_deleted) : []
		},
		visibleProducts(page) {
			return page.products ? page.products.filter(x => !x.is_deleted) : []
		},
	},
	watch:{
		showPages(val,oVal){
			this.hidePages = !val
		}
	},
	created() {
	},
	mounted() {
		this.hidePages = !this.showPages;
	}
}
</script>

<style lang="scss" scoped>
.analytics-step {
	//&::before {
	//	content: "";
	//	display: flex;
	//	height: calc(100% - 10px);
	//	left: 30px;
	//	top: 50px;
	//	width: 2px;
	//	background: #ebeff5;
	//	position: absolute;
	//	z-index: 2;
	//	bottom: -10px;
	//}

	&::after {
		content: '';
		display: flex;
		height: 10px;
	}

}
</style>
